export default {
    /** 共通 **/
  //  getListObj (state) {
  //      return state.listObj.data
  //  },
  //  getListObjLoadStatus (state) {
  //      return state.listObjLoadStatus
  //  },
  //  getListObjSeeMoreLoadStatus (state) {
  //      return state.listObjSeeMoreLoadStatus
  //  },

    /** point **/
    getPoint (state) {
        return state.point.data
    },
    getPointLoadStatus (state) {
        return state.pointLoadStatus
    },

    /** 招待情報 **/
    getInviteInfo (state) {
        return state.inviteInfo.data
    },
    getInviteInfoLoadStatus (state) {
        return state.inviteInfoLoadStatus
    },
    getCompanys (state) {
        return state.companys.data
    },
    getCompanysLoadStatus (state){
        return state.companysLoadStatus
    },
    getDelCompanyStatus (state) {
        return state.delCompanyStatus
    },
    getAddCompanyStatus (state) {
        return state.addCompanyStatus
    },
    getCurrentCompany (state) {
        let currentCompany = state.currentCompany
        try {
            if (sessionStorage.company) {
                currentCompany = sessionStorage.company
            }
        } catch (e){}

        return currentCompany
    },
    getShareInviteCodeStatus (state) {
        return state.shareInviteCodeStatus
    },
    getCompanyDetail (state) {
        return state.companyDetail
    },
    getCompanyDetailLoadStatus (state) {
        return state.companyDetailLoadStatus
    },
    getCompanyInviteDetailChangeStatus (state) {
        return state.companyInviteDetailChangeStatus
    },
    getCompanyOperat (state) {
        return state.companyOperat
    },
    getSaveCompanyInfoStatus (state) {
        return state.saveCompanyInfoStatus
    },
    getTechLevel (state) {
        return state.techLevel.data
    },
    getTechLevelLoadStatus (state){
        return state.techLevelLoadStatus
    },
    getTechChildList (state) {
        return state.techChild.data
    },
    getTechChildLoadStatus (state) {
        return state.techChildLoadStatus
    },

    /** 履歴書一覧 **/
    getTechResume (state) {
        return state.techResume
    },
    getTechResumeLoadStatus (state) {
        return state.techResumeLoadStatus
    },
    getTechResumeHasChangeForInputBarStatus (state) {
        return state.techResumeHasChangeForInputBarStatus
    },
    /** 履歴書配信Flg更新 **/
    getChangeTechResumeMailFlg (state) {
        return state.changeTechResumeMailFlg
    },
    getChangeTechResumeMailFlgStatus (state) {
        return state.changeTechResumeMailFlgStatus
    },
    /** 受信日最新化  **/
    getUpdateTechResumeRecentInDay (state) {
        return state.updateTechResumeRecentInDay
    },
    getUpdateTechResumeRecentInDayStatus (state) {
        return state.updateTechResumeRecentInDayStatus
    },

    /** 履歴書削除  **/
    getDeleteTechResumeStatus (state) {
        return state.deleteTechResumeStatus
    },

    /** 履歴書詳細 **/
    getResumeOperat (state) {
        return state.resumeOperat
    },
    getResumeInfo (state) {
        return state.resumeInfo
    },
    getSaveResumeInfoStatus (state) {
        return state.saveResumeInfoStatus
    },
    getResumeInfoLoadStatus (state) {
        return state.resumeInfoLoadStatus
    },
    
    getLatestPointInfo (state) {
        return state.latestPointInfo.data
    },
    getLatestPointInfoLoadStatus (state) {
        return state.latestPointInfoLoadStatus
    },
    getMakePointStatus (state) {
        return state.makePointStatus
    },
    /** 個人画面 **/
    getPersonInfo (state) {
        return state.personInfo
    },
    getPersonInfoLoadStatus (state) {
        return state.personInfoLoadStatus
    },
    getIdentityOkStatus (state) {
        return state.identityOkStatus
    },
    getIdentityNgStatus (state) {
        return state.identityNgStatus
    },

    /** 月明細 **/
    getPayStatusChangeItem (state) {
        return state.payStatusChangeItem
    },
    getPayStatusChangeStatus (state) {
        return state.payStatusChangeStatus
    },

}

